import styled from '@emotion/styled';
import { Magnetic } from '@mitchell/react.component.ux';
import { IntelligentAssignmentSummary, PhotoCaptureConstants } from '../../constants';
export const StyledIntelligentLandingPageContent = styled('div') `
	text-align: justify;
	width: 100%;
	padding: ${Magnetic.spacer20};
`;
export const StyledPhotoOptionsContainer = styled('div') `
	display: flex;
	flex-direction: column;
	gap: ${Magnetic.spacer12};
	margin-top: ${Magnetic.spacer32};
	width: 100%;
`;
export const StyledLandingPageTitle = styled('div') `
	font-weight: ${Magnetic.fontWeightHeavy};
	font-size: ${Magnetic.fontSize14};
	text-align: center;
`;
export const StyledPhotoOptionCard = styled('div') `
	display: flex;
	align-items: center;
	padding: ${Magnetic.spacer20} ${Magnetic.spacer40};
	background-color: ${Magnetic.colorWhite};
	border-radius: ${Magnetic.borderRadius05};
	cursor: pointer;
	box-shadow: ${Magnetic.boxShadow01};
`;
export const StyledPhotoOptionIcon = styled('div') `
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: ${Magnetic.borderRadius06};
	margin-right: ${Magnetic.spacer16};
	width: ${Magnetic.spacer40};
	height: ${Magnetic.spacer40};

	&::before {
		font-size: ${Magnetic.fontSize42};
		color: ${Magnetic.colorBrand50};
		line-height: 1;
	}
	&.${PhotoCaptureConstants.ICON_CLASS}::before {
		font-size: ${Magnetic.fontSize36};
	}
	&.${IntelligentAssignmentSummary.UPLOAD_FILES_ICON}::before {
		font-size: ${Magnetic.fontSize28};
	}
`;
export const StyledHeading = styled('p') `
	font-weight: ${Magnetic.fontWeightHeavy};
	font-size: ${Magnetic.fontSize14};
	color: ${Magnetic.colorBrand50};
`;
//# sourceMappingURL=IntelligentAssignmentSummaryLandingPageComponent.style.js.map